import * as ngCdkOverlay from '@angular/cdk/overlay'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

/**
 * Displays information about a selected/hovered item
 */
@ngCore.Component({
  imports: [ds.overlay.attached.Component],
  selector: 'atn-summit-allocation-graph-base-overlay',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Indicates where this overlay {@link Component} should be placed
   */
  public readonly originSg =
    ngCore.input.required<ngCdkOverlay.FlexibleConnectedPositionStrategyOrigin>(
      {
        alias: 'origin',
      },
    )

  /**
   * Dead zone radius where the overlay will not be displayed too close to the origin
   */
  public readonly deadZoneRadius = 10
}
